import { gql } from '@apollo/client';

export const QUERY_DELIVERY_MONITOR_HUBS = gql`
    query QueryDeliveryMonitorHubs {
        deliveryMonitorHubs {
            id
            sortingCode
            name
            warehouseCount
        }
    }
`;

export const QUERY_DELIVERY_MONITOR_WAREHOUSES = gql`
    query QueryDeliveryMonitorWarehouses($hubId: Long!) {
        deliveryMonitorWarehouses(hubId: $hubId) {
            id
            sortingCode
            name
            latitude
            longitude
        }
    }
`;

/**
 * KPI「补间 + 环比」——前端 10 分钟轮询本查询，用 previous → current 做 rAF 补间动画，
 * yesterday 用于「较昨日」环比标签。previous / yesterday 缺时跳过动画 / 不显示环比。
 */
export const QUERY_DELIVERY_MONITOR_DAILY_KPI_WITH_PREVIOUS = gql`
    query QueryDeliveryMonitorDailyKpiWithPrevious(
        $taskDate: String
        $hubId: Long
        $warehouseIds: [Long!]
        $asOfMs: Long
    ) {
        deliveryMonitorDailyKpiWithPrevious(
            taskDate: $taskDate
            hubId: $hubId
            warehouseIds: $warehouseIds
            asOfMs: $asOfMs
        ) {
            current {
                calcSlot
                calculatedAtMs
                scheduledParcels
                actualPickedUp
                deliveredParcels
                pickupRate
                deliveryRate
            }
            previous {
                calcSlot
                scheduledParcels
                actualPickedUp
                deliveredParcels
                pickupRate
                deliveryRate
            }
            yesterday {
                calcSlot
                scheduledParcels
                actualPickedUp
                deliveredParcels
                pickupRate
                deliveryRate
            }
        }
    }
`;

export const QUERY_DELIVERY_MONITOR_DRIVERS = gql`
    query QueryDeliveryMonitorDrivers(
        $taskDate: String
        $hubId: Long
        $warehouseIds: [Long!]
        $bucketFilter: DeliveryMonitorProgressBucket
        $sortBy: DeliveryMonitorDriverSort!
        $asOfMs: Long
    ) {
        deliveryMonitorDrivers(
            taskDate: $taskDate
            hubId: $hubId
            warehouseIds: $warehouseIds
            bucketFilter: $bucketFilter
            sortBy: $sortBy
            asOfMs: $asOfMs
        ) {
            driverAccountId
            driverName
            warehouseId
            allocatedParcels
            deliveredCount
            pendingCount
            deliveryRate
            bucket
        }
    }
`;

export const QUERY_DELIVERY_MONITOR_DRIVER_POSITIONS = gql`
    query QueryDeliveryMonitorDriverPositions(
        $taskDate: String
        $hubId: Long
        $warehouseIds: [Long!]
        $asOfMs: Long
    ) {
        deliveryMonitorDriverPositions(
            taskDate: $taskDate
            hubId: $hubId
            warehouseIds: $warehouseIds
            asOfMs: $asOfMs
        ) {
            driverAccountId
            driverName
            bucket
            latitude
            longitude
            bearing
            locationTimestampMs
            deliveryRate
            allocatedParcels
            track {
                latitude
                longitude
                bearing
                locationTimestampMs
            }
        }
    }
`;

export const QUERY_DELIVERY_MONITOR_DRIVER_DETAIL = gql`
    query QueryDeliveryMonitorDriverDetail(
        $driverAccountId: Long!
        $taskDate: String
    ) {
        deliveryMonitorDriverDetail(
            driverAccountId: $driverAccountId
            taskDate: $taskDate
        ) {
            driverAccountId
            allocatedParcels
            deliveredCount
            pendingCount
            deliveryRate
            packages {
                trackingNumber
                cityName
                addressLine1
                eventTimeMs
                status
            }
        }
    }
`;

export const QUERY_DELIVERY_MONITOR_DRIVER_TRAJECTORY = gql`
    query QueryDeliveryMonitorDriverTrajectory(
        $driverAccountId: String!
        $startTime: String!
        $endTime: String!
    ) {
        deliveryMonitorDriverTrajectory(
            driverAccountId: $driverAccountId
            startTime: $startTime
            endTime: $endTime
        ) {
            latitude
            longitude
            bearing
            locationTimestampMs
        }
    }
`;
